import React, { useCallback, useState } from 'react';

import { Icons } from '@components/common';
import PageTitle from '@components/common/PageTitle';
import ProfileTabSection from '@components/common/ProfileTabSection';

import { EAdminPanelPageTitles } from '@enums/common';

import colors from '@constants/colors';
import {
	MIDDLEWARE_TABS_NAMES,
} from './constants';

import MiddlewaresTable from './MiddlewaresTable/MiddlewaresTable';
import ConnectionLogs from './ConnectionLogs';
import { getMiddlewareTabs } from './utils';

import styles from './ManageMiddlewareSMO.module.scss';

const tabs = getMiddlewareTabs();

const ManageMiddlewareSMO = () => {
	const [currentTab, setCurrentTab] = useState(MIDDLEWARE_TABS_NAMES.middlewares);

	const getCurrentTab = useCallback(() => {
		switch (currentTab) {
			case MIDDLEWARE_TABS_NAMES.middlewares:
				return <MiddlewaresTable />;
			case MIDDLEWARE_TABS_NAMES.connectionLogs:
				return <ConnectionLogs />;
			default:
				return null;
		}
	}, [currentTab]);

	return (
		<div className={styles.wrapper}>
			<PageTitle
				icon={Icons.middlewareSMO({ isActive: true, color: colors.white })}
				title={EAdminPanelPageTitles.SMOLightMiddleware}
			/>
			<div className={styles.whiteWrapper}>
				<ProfileTabSection
					currentTab={currentTab}
					getCurrentTab={getCurrentTab}
					isWithoutShadow
					maxWidth='unset'
					setCurrentTab={setCurrentTab}
					tabs={tabs}
				/>
			</div>
		</div>
	);
};

export default ManageMiddlewareSMO;
